import { render, staticRenderFns } from "./pa-so-shorted-sku-expand.vue?vue&type=template&id=4855bf51&scoped=true&"
import script from "./pa-so-shorted-sku-expand.vue?vue&type=script&lang=js&"
export * from "./pa-so-shorted-sku-expand.vue?vue&type=script&lang=js&"
import style0 from "./pa-so-shorted-sku-expand.vue?vue&type=style&index=0&id=4855bf51&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4855bf51",
  null
  
)

export default component.exports